import configureStore from '../store'
import { v4 as uuidv4 } from 'uuid';
const { store } = configureStore()

const utilityHelper={}


utilityHelper.genDateKey=function(){
    let d = new Date();
    let h = d.getHours();
    let m = d.getMinutes();
    let s = d.getSeconds();
    
    return h + "" + m + "" + s;

}

utilityHelper.genTempAttNo=function(){
    let result = 'att' + uuidv4();
    return result;
}

utilityHelper.getDocType=function(po_no,accountAssetCategory,itemCategory,matNo,overLimit){
    // console.group("utilityHelper.getDocType()")
    // console.log("po_no: ",po_no)
    // console.log("accountAssetCategory: ",accountAssetCategory)
    // console.log("itemCategory: ",itemCategory)
    // console.log("matNo: ",matNo)
    // console.log("overLimit: ",overLimit)

    let poType=itemCategory==="D" || itemCategory==="L"  ?"service":"goods"
    let docType=""
    let isContract=po_no && po_no.startsWith('41')
    let isGSP=false;

    if(po_no && (po_no.startsWith('324') || po_no.startsWith('322')))
        isGSP = true;
    
    if(poType==="goods"){
        if(accountAssetCategory && accountAssetCategory.indexOf("A")>-1 && 
        (!itemCategory || itemCategory.length===0) && 
        (!matNo || matNo.length===0)
        ){
        //Purchase Asset
        docType=(isContract===true? "C-PA" : "P-PA")
        }
    
        if(accountAssetCategory && accountAssetCategory.indexOf("F")>-1 && 
        (!itemCategory || itemCategory.length===0) && 
        (!matNo || matNo.length===0)
        ){
            //Purchase Consumption
            docType=(isContract===true?"C-PC" : "P-PC")
        }

        if((!accountAssetCategory || accountAssetCategory.length===0) && 
        (!itemCategory || itemCategory.length===0) && 
        (matNo && matNo.length>0)
        ){
            //Purchase Stock
            docType= (isContract===true ? "C-PS" : "P-PS")
        }

        if(accountAssetCategory && accountAssetCategory.indexOf("J")>-1 && 
        (!itemCategory || itemCategory.length===0) && 
        (!matNo || matNo.length===0)
        ){
            //Account Assignment "J"
            docType= (isContract===true ? "C-PJM" : "P-PJM")
        }

        if(accountAssetCategory && accountAssetCategory.indexOf("J")>-1 && 
        (!itemCategory || itemCategory.length===0) && 
        (matNo && matNo.length>0)
        ){
            //Account Assignment "J"
            docType=(isContract===true ? "C-PJN" : "P-PJN")
        }
    }

    if(poType==="service"){
        if(accountAssetCategory && accountAssetCategory.indexOf("A")>-1 && 
        (itemCategory && itemCategory.indexOf("D")>-1) && 
        (!matNo || matNo.length===0) && 
        (!overLimit || overLimit.length===0)
        ){
            //Service Asset (Plan)
            docType=(isContract===true ? "C-SPA" : "P-SPA")
            docType=(isContract===false && isGSP === true ? docType+"-GSP":docType)
        }

        if(accountAssetCategory && accountAssetCategory.indexOf("F")>-1 && 
        (itemCategory && itemCategory.indexOf("D")>-1) && 
        (!matNo || matNo.length===0) && 
        (!overLimit || Number(overLimit)<=0)
        ){
            //Service Consumption (Plan)
            docType=(isContract===true ? "C-SPC" : "P-SPC")
            docType=(isContract===false && isGSP === true ? docType+"-GSP":docType)
        }

        if(accountAssetCategory && accountAssetCategory.indexOf("J")>-1 && 
        (itemCategory && itemCategory.indexOf("D")>-1) && 
        (!matNo || matNo.length===0) && 
        (!overLimit || Number(overLimit)<=0)
        ){
            //Service Assignment "J" (Plan)
            docType=(isContract===true ? "C-SPJ" : "P-SPJ")
        }

        if(accountAssetCategory && accountAssetCategory.indexOf("A")>-1 && 
        (itemCategory && itemCategory.indexOf("D")>-1) && 
        (!matNo || matNo.length===0) && 
        (overLimit && Number(overLimit)>0)
        ){
            //Service Asset (UnPlan)
            docType=(isContract===true ? "C-SUA" : "P-SUA")
        }

        if(accountAssetCategory && accountAssetCategory.indexOf("F")>-1 && 
        (itemCategory && itemCategory.indexOf("D")>-1) && 
        (!matNo || matNo.length===0) && 
        (overLimit && Number(overLimit)>0)
        ){
            //Service Consumption (UnPlan)
            docType=(isContract===true ? "C-SUC" : "P-SUC")
        }

        if(accountAssetCategory && accountAssetCategory.indexOf("J")>-1 && 
        (itemCategory && itemCategory.indexOf("D")>-1) && 
        (!matNo || matNo.length===0) && 
        (overLimit && Number(overLimit)>0)
        ){
            //Account Assignment "J" (Unplan)
            docType=(isContract===true ? "C-SUJ" : "P-SUJ")
        }

        if(accountAssetCategory && accountAssetCategory.indexOf("A")>-1 && 
        (itemCategory && itemCategory.indexOf("L")>-1) && 
        (!matNo || matNo.length===0) 
        ){
            docType=(isContract===true ? "C-SPAL" : "P-SPAL")
        }

        if(accountAssetCategory == null && 
        (itemCategory && itemCategory.indexOf("L")>-1) && 
        (!matNo || matNo.length > 0) 
        ){
            docType=(isContract===true ? "C-SL" : "P-SL")
        }
    }

    // console.log("docType: ", docType)
    // console.groupEnd()

    return docType
}

utilityHelper.toSelectList=function(items,fieldDisplay,fieldValue){
    if(!items)return null
    let result=null

    if(items){
        result=items.map(item=> {
                return {
                    value: item[fieldValue],
                    label: item[fieldDisplay] 
                }
            })
        }
    return result
}

utilityHelper.toSelectList_CombineFields=function(items,fieldDisplay1,fieldDisplay2,fieldValue){
    if(!items)return null
    let result=null

    if(items){
        result=items.map(item=> {
                return {
                    value: item[fieldValue],
                    label: item[fieldDisplay1] + ' : ' + item[fieldDisplay2] 
                }
            })
        }
    return result
}

utilityHelper.toSelectList2=function(items,fieldDisplay,fieldValue){
    if(!items)return null
    let result=null

    if(items){
        result=items.map(item=> {
                return {
                    value: item[fieldValue],
                    label: item[fieldValue] + ' ' + item[fieldDisplay] 
                }
            })
        }
    return result
}

utilityHelper.checkIsContract = function(po_no){
    let isContract = (po_no && po_no.startsWith('41') ? true : false)
    return isContract
}

utilityHelper.parseFloat = function (value) {
    if (value != null) {
        var l = (value + "").length - ((value + "").replace(/\./g, '')).length;
        if (l > 1) {
            value = "";
        }
    }
    var ret = parseFloat((value + "").replace(/,/g, ''));

    if (isNaN(ret)) ret = 0;
    return ret;
}

utilityHelper.parseInt = function (value) {
    if (value != null) {
        var l = (value + "").length - ((value + "").replace(/\./g, '')).length;
        if (l > 1) {
            value = "";
        }
    }
    var ret = parseInt((value + "").replace(/,/g, ''));

    if (isNaN(ret)) ret = 0;
    return ret;
}

export default utilityHelper